import Vue from 'vue';
import billTransformer from './../../transformers/bill';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentBill', billTransformer.fetch(data));
  // resolve(billTransformer.fetch(data));
  resolve();
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(billTransformer.fetch(errors));
};

export default (id, bill) => (
  new Promise((resolve, reject) => {
    const b = billTransformer.send(bill);
    if (typeof b.order_id === 'object') {
      b.order_id = b.order_id.id;
    }
    Vue.$http.put(`/bills/${id}`, b)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/update.js